import { render, staticRenderFns } from "./GameInfo.vue?vue&type=template&id=ef5d57a0&scoped=true"
import script from "./GameInfo.vue?vue&type=script&lang=js"
export * from "./GameInfo.vue?vue&type=script&lang=js"
import style0 from "./GameInfo.vue?vue&type=style&index=0&id=ef5d57a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5d57a0",
  null
  
)

export default component.exports